import { REACT_APP__ENVIRONMENT } from "@smp/utils";

const log = (params: Record<string, boolean | number | string>) => {
  if (
    REACT_APP__ENVIRONMENT === "staging" ||
    REACT_APP__ENVIRONMENT === "staging.io"
  ) {
    console.log(
      `%c gsc send user extra params: ${JSON.stringify(params)}`,
      "background: #222; color: #bada55",
    );
  }
};

export const gscSendUserParams = (
  userParams: Record<string, boolean | number | string>,
) => {
  log(userParams);
  window.gsc && window.gsc("params", { ...userParams });
};
